import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import { ErrorBoundary } from "./components/ErrorBoundary.jsx";
import { applyTheme } from "./lib/theme.js";
import { loadSession } from "./lib/storage.js";
import { DEFAULT_ACCENT } from "@prism/shared/constants";
import "./index.css";

// Apply theme synchronously before first paint so there's no default-orange
// flash when a signed-in user has a custom accent color. AuthProvider will
// reapply the theme on state change — this is only for the initial paint.
const stored = loadSession();
applyTheme(stored?.client?.accentColor || DEFAULT_ACCENT);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {/* Last-resort boundary for crashes outside the Shell (login pages,
        providers). Page-level crashes are caught by the inner boundary in
        App.jsx's Shell so the sidebar survives. */}
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
